import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
} from "@chakra-ui/core";
import React from "react";

import { getClosureState } from "../services/closure.service";

type Props = {
  city?: string;
};

function ClosureAlert({ city }: Props): JSX.Element | null {
  const closureState = getClosureState(city);

  if (!closureState.isClosed) return null;

  return (
    <Alert
      status="error"
      w="100%"
      my={2}
      // A sötét téma globális fehér szövegszíne olvashatatlan a világos
      // alerten, ezért a szín itt explicit. Kerekítés/árnyék a Card mintájára.
      color="red.800"
      borderRadius="8px"
      shadow="0 8px 10px 0 rgba(10, 31, 68, 0.15), 0 0 1px 0 rgba(10, 31, 68, 0.1)"
    >
      <AlertIcon />
      <Box flex="1">
        <AlertTitle mr={2} color="red.800">
          Üzletünk zárva van!
        </AlertTitle>
        <AlertDescription color="red.800">
          {closureState.message}
        </AlertDescription>
      </Box>
    </Alert>
  );
}

export default ClosureAlert;
